(() => {
  const SELECTOR = '[data-brassium-video-hero]';

  function activeSource(section) {
    const mobile = section.querySelector('.brassium-video-hero__source--mobile');
    const desktop = section.querySelector('.brassium-video-hero__source--desktop');
    const all = section.querySelector('.brassium-video-hero__source--all');
    if (all) return all;
    if (window.matchMedia('(min-width: 750px)').matches) return desktop || mobile;
    return mobile || desktop;
  }

  function buildExternal(section, source, autoplay) {
    if (!source) return null;
    const mount = source.querySelector('[data-external-player]');
    if (!mount) return null;
    if (mount.querySelector('iframe')) return mount.querySelector('iframe');

    const host = source.dataset.externalHost;
    const id = source.dataset.externalId;
    if (!host || !id) return null;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('title', 'Video');

    if (host === 'youtube') {
      const params = new URLSearchParams({
        playsinline: '1',
        rel: '0',
        modestbranding: '1',
        enablejsapi: '1',
        playlist: id
      });
      if (autoplay) {
        params.set('autoplay', '1');
        params.set('controls', '0');
        params.set('mute', '1');
        params.set('loop', '1');
      } else {
        params.set('autoplay', '1');
      }
      iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?${params.toString()}`;
    } else if (host === 'vimeo') {
      const params = new URLSearchParams({
        responsive: '1',
        portrait: '0',
        title: '0',
        byline: '0'
      });
      if (autoplay) {
        params.set('background', '1');
        params.set('autoplay', '1');
        params.set('loop', '1');
        params.set('muted', '1');
      } else {
        params.set('autoplay', '1');
      }
      iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?${params.toString()}`;
    }

    mount.appendChild(iframe);
    return iframe;
  }

  function play(section) {
    const source = activeSource(section);
    if (!source) return;

    const video = source.querySelector('video');
    if (video) {
      const result = video.play();
      if (result && typeof result.catch === 'function') result.catch(() => {});
      section.classList.add('is-playing');
      return;
    }

    if (source.matches('.brassium-video-hero__source--external')) {
      buildExternal(section, source, false);
      section.classList.add('is-playing');
    }
  }

  function init(section) {
    if (!section || section.dataset.bvhReady === 'true') return;
    section.dataset.bvhReady = 'true';

    const autoplay = section.dataset.autoplay === 'true';
    const playButton = section.querySelector('[data-video-play]');
    if (playButton) playButton.addEventListener('click', () => play(section));

    if (!autoplay) {
      section.querySelectorAll('video').forEach((video) => {
        video.addEventListener('play', () => section.classList.add('is-playing'));
      });
      section.querySelector('[data-video-stage]')?.addEventListener('click', (event) => {
        if (event.target.closest('[data-video-play]')) return;
        if (event.target.closest('video[controls]')) return;
        if (!section.classList.contains('is-playing')) play(section);
      });
    } else {
      const external = section.querySelector('.brassium-video-hero__source--external');
      if (external) buildExternal(section, external, true);
    }
  }

  function boot(root = document) {
    root.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
